var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('h4',{staticClass:"subtitle-2 font-weight-medium"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"body-1 font-weight-medium"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.formattedValue)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }